import React from "react";
import * as FaIcons from "react-icons/fa";
import * as DiIcons from "react-icons/di";
import * as SiIcons from "react-icons/si";
import { NavLink } from "react-router-dom";
import { Navbar, NavbarBrand, Nav } from 'reactstrap';

const SideBarRealisations = () => {
    return (
        <div className="col-2 px-0" style={{ background: "#000000" }}>
            {/* <FaIcons.FaBars style={{ color: "#daef0a" }} />Mes realisations */}
            <Navbar className="mr-auto-sideBar ">
                <NavbarBrand href="#" style={{margin:"auto"}}> <FaIcons.FaHandPointDown style={{ color: "#00ff00", fontSize: "1.5em" }} /></NavbarBrand>
                <Nav className="sidbarItem p-0 ">
                    <NavLink className="nav-link" exact to="/realisations">
                        This<DiIcons.DiReact className="reactIconSide" />
                    </NavLink>
                    <NavLink className="nav-link" exact to="/realisations/jsRealisations">
                        <SiIcons.SiJavascript className="jsIconSide" />
                    </NavLink>
                    <NavLink className="nav-link" exact to="/realisations/mernRealisations">
                        MERN
                        <FaIcons.FaNode style={{ color: "#00ff00", fontSize: "1.5em" }} />
                    </NavLink>
                    <NavLink className="nav-link" exact to="/realisations/symfonyRealisations">
                        <DiIcons.DiSymfonyBadge className="symfonyIconSide" />
                    </NavLink>
                    <NavLink className="nav-link" exact to="/realisations/reactNativeRealisations">
                        <DiIcons.DiReact className="reactIconSide" />Native
                    </NavLink>
                    <NavLink className="nav-link" exact to="/realisations/javaRealisations">
                        <DiIcons.DiJava className="javaIconSide" />
                    </NavLink>
                    <NavLink className="nav-link" exact to="/realisations/androidJavaRealisations">
                        <DiIcons.DiAndroid className="androidIconSide" />
                    </NavLink>
                </Nav>
            </Navbar>
        </div>
    )
}

export default SideBarRealisations;